import { red } from '@mui/material/colors'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(() => ({
  container: {
    width: '100%',
    height: 70,
    position: 'fixed',
    bottom: 0,
    boxShadow: '8px 4px 4px 4px rgba(0, 0, 0, 0.25)',
    display: 'flex',
    backgroundColor: 'white',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    zIndex: 10,
    '@media all and (min-width: 480px) and (max-width: 767px)': {
      justifyContent: 'space-around'
    },
    '@media all and (max-width: 479px)': {
      justifyContent: 'space-around'
    }
  },
  /* more: {
    display: 'none',
    '@media all and (max-width: 720px)': {
      display: 'flex'
    }
  }, */
  tasks: {
    display: 'flex',
    '@media all and (max-width: 720px)': {
      display: 'none'
    }
  },
  expiry: {
    display: 'flex',
    '@media all and (max-width: 720px)': {
      display: 'none'
    }
  },
  items: {
    size: 50,
    color: red
  },
  icon: {
    borderRadius: '8px',
    height: 44,
    width: 44,
    cursor: 'pointer',
    display: 'flex',
    color: '#24378F',
    fontSize: 30,
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'all .2s ease-in',
    '&:hover': {
      backgroundColor: '#00A88F',
      transform: 'translateY(-2px)'
    }
  }
}))

export default useStyles
